<template>
    <div class="index-item-wrap">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            <el-button type="success" size="mini" @click="handleAdd" class="header-btn">新增</el-button>
        </div>

        <el-table :data="getIndexItemList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column prop="itemSn" label="排序号" width="60"></el-table-column>
            <el-table-column prop="itemTypeName" label="类型"></el-table-column>
            <el-table-column prop="itemName" label="关联品"></el-table-column>
            <el-table-column prop="moduleListName" label="列表模板"></el-table-column>
            <el-table-column prop="mobuleDetailName" label="详情模板"></el-table-column>
            <el-table-column label="是否有效">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.isShow == 1" type="success" size="small">有效</el-tag>
                    <el-tag v-if="scope.row.isShow == 0" type="danger" effect="dark" size="small">无效</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="unShowReason" label="无效原因"></el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary"  size="mini" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="danger " size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>

                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="类别">
                    <el-select v-model="form.itemType" clearable filterable  placeholder="类别" @change="handlePlatformChange">
                        <el-option v-for="item in itemTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品">
                    <el-select v-model="form.proId" clearable filterable placeholder="商品">
                        <el-option v-for="item in items"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="显示导航模板">
                    <el-select v-model="form.indexShowType" clearable  placeholder="是否显示在首页导航模板">
                        <el-option v-for="item in indexShowTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">选是 显示在首页导航模板，选否 会显示在更多里面</span>
                </el-form-item>
                <el-form-item label="列表模板">
                    <el-select v-model="form.buildPageId" clearable filterable  placeholder="列表模板">
                        <el-option v-for="item in buildPageDataSelect"
                                :key="item.buildPageId"
                                :label="item.pageName"
                                :value="item.buildPageId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详情模板">
                    <el-select v-model="form.detailBuildPageId" clearable filterable  placeholder="详情模板">
                        <el-option v-for="item in detailBuildPageData"
                                   :key="item.buildPageId"
                                   :label="item.pageName"
                                   :value="item.buildPageId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序号">
                    <el-input-number v-model="form.itemSn"  :min="0" :max="10000" label="排序号"></el-input-number>
                </el-form-item>

                <el-form-item>

                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getIndexItemList,getIndexItem,saveIndexItem,deleteIndexItem,getItems} from '../../api/api'

    //定义组件
    export default{
        data(){
            return {
                getIndexItemList:[],
                itemTypeData:[],
                itemData:[],
                buildPageData:[],
                buildPageDataSelect:[],
                detailBuildPageData:[],
                items:[],
                loading:true,
                platformId:0,
                navType:0,
                selectValue: 0,
                dialogFormVisible:false,
                indexNavId:this.$route.params.indexNavId,
                indexShowTypeList:[{"id":0,"name":"不显示在首页导航"},{"id":1,"name":"显示在首页导航"}],
                form:{
                    "itemType":0,
                    "proId":"",
                    "buildPageId":"",
                    "detailBuildPageId":"",
                    "itemSn":0,
                    "indexItemId":0,
                    "navId":"",
                    "indexShowType":0
                },
                formInline:{
                    "job_name":"",
                    "job_group":"",
                },

            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList(this.indexNavId);
            this.form.navId=this.indexNavId;
        },

        methods:{
            //定义查询方法
            getList(indexNavId){
                getIndexItemList({indexNavId:indexNavId}).then((res) => {
                    this.loading = false;
                    this.getIndexItemList = res.data.value;
                    //this.recordsTotal = res.data.total;
                })
            },
            handleDel(row){
                if(confirm("确定删除选中的行吗？")) {
                    deleteIndexItem({indexItemId: row.indexItemId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.indexNavId);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }
            },
            handlePlatformChange(data){
                //商品
                getItems({itemType:data}).then((res) => {
                    console.log(res);
                    this.items = res.data;
                });
                // 控制列表模板：单品显示：
                this.buildPageDataSelect = [];
                for(var i=0 ;i < this.buildPageData.length;i++){
                    if(this.buildPageData[i].salesType == data){
                        this.buildPageDataSelect.push(this.buildPageData[i]);
                    }
                }
            },
            handleAdd(){
                var d={indexItemId:""};

                this.handleEdit(d);
                this.form.itmeSn=0;
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                //得到实体
                getIndexItem({indexItemId:data.indexItemId,indexNavId:this.indexNavId}).then((res) => {
                    console.log(res);
                    this.itemTypeData=res.data.value.itemTypeData;
                    this.itemData=res.data.value.indexItem;
                    this.buildPageData=res.data.value.buildPageData;
                    this.detailBuildPageData=res.data.value.detailBuildPageData;
                    this.form = this.itemData;
                    if(data.indexItemId==''){
                        this.form.indexShowType=0;
                    }
                    this.items=res.data.value.items;
                    // 控制列表模板：单品显示：
                    this.buildPageDataSelect = [];
                    for(var i=0 ;i < this.buildPageData.length;i++){
                        if(this.buildPageData[i].salesType == this.form.itemType){
                            this.buildPageDataSelect.push(this.buildPageData[i]);
                        }
                    }
                });
            },
            save(data){
                if(data.itemType==null||data.itemType==""){
                    this.$message({
                        message:"请选择类别",
                        type:'error'
                    });
                    return;
                }
                if(data.proId==""||data.proId==null){
                    this.$message({
                        message:"请选择商品",
                        type:'error'
                    });
                    return;
                }
                if(data.buildPageId==""||data.buildPageId==null){
                    this.$message({
                        message:"请选择列表模板",
                        type:'error'
                    });
                    return;
                }
                if(data.detailBuildPageId==""||data.detailBuildPageId==null){
                    this.$message({
                        message:"请选择详情模板",
                        type:'error'
                    });
                    return;
                }

                console.log(data);
                saveIndexItem(data).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.dialogFormVisible=false;
                        this.getList(this.indexNavId);
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }


                });

            },
            returnHistory(){
                window.history.go(-1)
            }
        }
    }

</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .index-item-wrap{
        padding: 10px 20px;
        .header-return{
            margin-bottom: 20px;
            padding-bottom: 10px;
        }
        .header-btn{
            float: right;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/pageconfig/indexItemList.vue